export const TEXTS = {
  MODAL_BIND_SUCCESS_TITLE: 'Устройство привязано!',

  MODAL_BIND_SUCCESS_NO_STREAM_DESC: 'Выберите музыку для своего заведения',
  MODAL_BIND_SUCCESS_ADDRESS_NO_ACTIVE_DESC: 'Для запуска необходимо оплатить адрес',
  MODAL_BIND_SUCCESS_DESC: 'Треки загружаются. Музыка заиграет на вашем плеере в ближайшее время, ожидайте.',

  MODAL_BIND_SUCCESS_BUTTON_OPEN_STREAMS_TEXT: 'Выбрать волну',
  MODAL_BIND_SUCCESS_BUTTON_OPEN_WEB_PLAYER_TEXT: 'Открыть веб-плеер',
  MODAL_BIND_SUCCESS_BUTTON_CLOSE_TEXT: 'Хорошо',
};
